import { Row, Col, FormGroup } from 'react-bootstrap';
import React, { Component } from 'react';
import FormularioPadrao from '../FormularioPadrao';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import ConfirmacaoDeLocalizacaoController from '../../controllers/Empresa/ConfirmacaoDeLocalizacaoController';
import { dateTimeToString } from '../../utils/Functions';
import SubCadastro from '../../components/SubCadastro';

export default class ConfirmacaoDeLocalizacaoView extends Component {
   constructor(props) {
      super(props);
      this.state = { mostrarAcessos: true };
      this.controller = new ConfirmacaoDeLocalizacaoController(this);
   }

   renderizarFormulario = () => {
      let lang = this.props.lang;
      return (
         <React.Fragment>
            <Row>
               <Col sm={3} md={3} lg={3} xl={3}>
                  <FormGroup>
                     <Label>{lang.codigo}</Label>
                     <TextInput readOnly defaultValue={this.state.itemSelecionado.id} />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{'Data'}</Label>
                     <TextInput defaultValue={dateTimeToString(this.state.itemSelecionado.data)} readOnly />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{'Usuário'}</Label>
                     <TextInput defaultValue={this.state.itemSelecionado.usuario?.nome} readOnly />
                  </FormGroup>
               </Col>
            </Row>
            <Row>
               <Col>
                  <FormGroup>
                     <Label>{'Local'}</Label>
                     <TextInput defaultValue={this.state.itemSelecionado.local?.nome} readOnly />
                  </FormGroup>
               </Col>
            </Row>
            <Row>
               <Col sm={12} md={6} lg={6} xl={6}>
                  <FormGroup>
                     <Label>{'Celular'}</Label>
                     <TextInput defaultValue={this.state.itemSelecionado.gateway.descricao} readOnly />
                  </FormGroup>
               </Col>

               <Col sm={12} md={6} lg={6} xl={6}>
                  <FormGroup>
                     <Label>{'MAC'}</Label>
                     <TextInput defaultValue={this.state.itemSelecionado.gateway?.mac} readOnly />
                  </FormGroup>
               </Col>
            </Row>

            <SubCadastro
               titulo={'Leituras'}
               itens={this.state.itemSelecionado.leituras}
               lang={this.props.lang}
               colunas={() => {
                  return [
                     { titulo: 'MAC', width: '20%' },
                     { titulo: 'Monitorado', width: '50%' },
                     { titulo: 'N/S', width: '15%' },
                     { titulo: 'Patrimônio', width: '15%' },
                  ];
               }}
               linha={(item) => {
                  return [item.mac, item.monitorado?.nome, item.monitorado?.numeroDeSerie, item.monitorado?.patrimonio];
               }}
            />
         </React.Fragment>
      );
   };

   render() {
      return (
         <FormularioPadrao
            titulo={'Confirmação de localização'}
            url={'/confirmacaodelocalizacao'}
            api={this.props.api}
            lang={this.props.lang}
            ordenacaoPadrao={'id desc'}
            permissoes={[1541, null, null, null]}
            getFiltro={this.controller.getFiltro}
            getTitulosDaTabela={this.controller.getTitulosDaTabela}
            getDadosDaTabela={this.controller.getDadosDaTabela}
            renderizarFormulario={this.renderizarFormulario}
            getObjetoDeDados={this.controller.getObjetoDeDados}
            antesDeInserir={this.controller.antesDeInserir}
            antesDeEditar={this.controller.antesDeEditar}
            antesDeSalvar={this.controller.antesDeSalvar}
            antesDeExcluir={this.controller.antesDeExcluir}
            getFormState={() => {
               return this.state;
            }}
            setFormState={(state, callback) => {
               return new Promise((resolve) => {
                  this.setState(state, () => {
                     resolve();
                     if (callback) {
                        callback();
                     }
                  });
               });
            }}
            select={this.props.select}
            itemVazio={{}}
         />
      );
   }
}
